import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {get} from 'lodash';
import Highcharts from 'highcharts';

import {getPracticeBasedTitle} from '../utils';
import InlineEdit from "common/InlineEdit";

export default function ({printable}) {

    const me = useSelector(state => state.me);
    const dashboard = useSelector(state => state.insights_dashboard);
    const dashboard_data = useSelector(state => state.dashboard_data);
    const [title, setTitle] = useState('');

    const graph_id = 'pam-category-graph';
    let category_data = dashboard_data.category_data;

    // Only show data graph in Mindsets University Dashboard for now
    // This is tmp for testing
    // const school_name = get(dashboard, 'project.school.name', '');
    // const district_name = get(dashboard, 'project.district.name', '');
    // if (school_name.toUpperCase() != "MINDSETS UNIVERSITY" && district_name.toUpperCase() != "MINDSETS UNIVERSITY") {
    //     if (category_data) {
    //         const i = findIndex(category_data.categories, (n) => n == 'Math - Concepts & Procedures');
    //         if (i >= 0) {
    //             category_data = cloneDeep(category_data);
    //             remove(category_data.categories, (n, k) => k === i);
    //             forEach(category_data.series, (s) => {
    //                 remove(s.data, (n, k) => k === i);
    //             });
    //         }
    //     }
    // }

    useEffect(() => {
        if (category_data) {
            draw();
        }
    }, [category_data]);
    useEffect(() => {
        const new_title = getPracticeBasedTitle(dashboard).category;
        if (title !== new_title) {
            setTitle(new_title);
        }
    }, [dashboard]);

    function getPointWidth() {
        const n = get(category_data, 'categories', []).length;
        return Math.round(250 / n);
    }

    function draw() {
        const graph = {
            chart: {
                type: 'column',
                marginBottom: 150,
                height: 500
            },
            // title: {
            //     text: getPracticeBasedTitle(dashboard).category,
            //     style: {
            //         fontWeight: 'bolder',
            //         fontSize: '18px'
            //     }
            // },
            title: null,
            xAxis: {
                categories: category_data.categories
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Student Achievement'
                },
                labels: {
                    format: '{text}%'
                }
            },
            tooltip: {
                pointFormat: '<span>{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                shared: true
            },
            plotOptions: {
                column: {
                    stacking: 'percent',
                    maxPointWidth: 70,
                    pointWidth: getPointWidth()
                }
            },
            series: category_data.series,
            legend: {
                enabled: true,
                reversed: true
            },
            credits: {
                enabled: false
            }
        }

        if (printable) {
            graph.tooltip.enabled = false;
        }

        Highcharts.chart(graph_id, graph)
    }

    function renderTitle() {
        if (me.is_dashboard_super_admin) {
            return (
                <InlineEdit
                    activeClassName="pam-chart-title-input"
                    text={title}
                    paramName="title"
                    change={prop => setTitle(prop.title)}
                    minLength={1}
                    maxLength={500}
                    className='pam-chart-title'
                    staticElement='div'
                    withIcon={false}
                />
            );
        }

        return (
            <div className='pam-chart-title'>{title}</div>
        );
    }

    if (category_data === undefined || !me) {
        return null;
    }

    return (
        <div>
            <div className="pam-component">
                {renderTitle()}
                <div id={graph_id}/>
            </div>
        </div>
    );
}
